import styled from 'styled-components';

export const StyledChevron = styled.svg<{
  disabled?: boolean;
  isOpened?: boolean;
  color?: string;
}>`
  position: relative;
  vertical-align: middle;
  margin-left: 4px;
  display: inline-block;
  color: ${({ theme, disabled, color }) => (
    (disabled) ?
      theme.colors.darkGray :
      color || theme.colors.light
  )};
  pointer-events: none;
`;
